export default __webpack_public_path__ + "static/media/smoke.fe48ea96.png";